module.exports = __webpack_public_path__ + "img/speed.54cce33c.png";